var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return this.deliveryAddress ? _c('div', [_c('router-view')], 1) : _c('div', [_c('noservice')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }